var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-success"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 61
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success",
    clipPath: "url(#clip-success)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-check-circle",
    "data-name": "Icon material-check-circle",
    d: "M30.5,3A27.5,27.5,0,1,0,58,30.5,27.51,27.51,0,0,0,30.5,3ZM25,44.25,11.25,30.5l3.877-3.878L25,36.468,45.873,15.6l3.877,3.9Z",
    transform: "translate(1.904 0.404)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7ab67f7037683e7ee25374ca93a3d431.svg";
export { ForwardRef as ReactComponent };